export default {
  namespaced: true,

  state: {
    token: localStorage.getItem('token'),
    user: JSON.parse(localStorage.getItem('user')) || { name: '' },
    isAuthenticated: !!localStorage.getItem('token'),
  },

  mutations: {
    login(state, { user, token }) {
      state.user = user;
      state.token = token;
      state.isAuthenticated = true;
    },
    logout(state) {
      state.user = {};
      state.token = null;
      state.isAuthenticated = false;
    },
  },
};
